// import React from "react";
// import { NavLink } from "react-router-dom";
// import "bootstrap-icons/font/bootstrap-icons.css";

// const BottomNavbar = () => {
//   return (
//     <nav
//       className="bg-light border-top shadow-sm  position-fixed bottom-0 w-100"
//       style={{ zIndex: 1000  , }}
//     >
//       <div
//         className="d-flex justify-content-around align-items-center py-2"
//         style={{ fontSize: "0.9rem" }}
//       >
//         <NavLink
//           to="/userDashboard"
//           className={({ isActive }) =>
//             `text-decoration-none text-center ${isActive ? "text-primary" : "text-dark"}`
//           }
//         >
//           <i className="bi bi-house-door-fill fs-5 d-block"></i>
//           Home
//         </NavLink>

//         <NavLink
//           to="https://www.nseindia.com/"
//           className={({ isActive }) =>
//             `text-decoration-none text-center ${isActive ? "text-primary" : "text-dark"}`
//           }
//         >
//           <i className="bi bi-star-fill fs-5 d-block"></i>
//           Watchlive
//         </NavLink>

//         <NavLink
//           to="/portfolio"
//           className={({ isActive }) =>
//             `text-decoration-none text-center ${isActive ? "text-primary" : "text-dark"}`
//           }
//         >
//           <i className="bi bi-folder-fill fs-5 d-block"></i>
//           Portfolio
//         </NavLink>

//         <NavLink
//           to="/dashboard"
//           className={({ isActive }) =>
//             `text-decoration-none text-center ${isActive ? "text-primary" : "text-dark"}`
//           }
//         >
//           <i className="bi bi-grid-3x3-gap-fill fs-5 d-block"></i>
//           Dashboard
//         </NavLink>

//         <NavLink
//           to="/UserAccount"
//           className={({ isActive }) =>
//             `text-decoration-none text-center ${isActive ? "text-primary" : "text-dark"}`
//           }
//         >
//           <i className="bi bi-person-circle fs-5 d-block"></i>
//           Account
//         </NavLink>
//         <NavLink
//           to="/profile"
//           className={({ isActive }) =>
//             `text-decoration-none text-center ${isActive ? "text-primary" : "text-dark"}`
//           }
//         >
//           <i className="bi bi-person-circle fs-5 d-block"></i>
//           profile
//         </NavLink>
        
//       </div>
//     </nav>
//   );
// };

// export default BottomNavbar;


import React from "react";
import { NavLink } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";

const BottomNavbar = () => {
  return (
    <>
      {/* ⭐ Mobile ke liye text/icon size chhota — screen jitni chhoti utna compact */}
      <style>
        {`
          .bottom-navbar-link {
            font-size: 0.75rem;
          }
          .bottom-navbar-link i {
            font-size: 1.1rem !important;
          }

          @media (max-width: 400px) {
            .bottom-navbar-link {
              font-size: 0.62rem;
            }
            .bottom-navbar-link i {
              font-size: 1rem !important;
            }
            .bottom-navbar-inner {
              padding-left: 2px;
              padding-right: 2px;
            }
          }
        `}
      </style>

      <nav
        className="bg-light border-top shadow-sm"
        style={{
          zIndex: 1000,
          position: "fixed", // ⭐ bootstrap class ke bharose na rehkar inline se bhi force kiya
          bottom: 0,
          left: 0,
          right: 0,
          width: "100%",
        }}
      >
        <div
          className="d-flex justify-content-around align-items-center py-2 bottom-navbar-inner"
        >
          <NavLink
            to="/userDashboard"
            className={({ isActive }) =>
              `text-decoration-none text-center bottom-navbar-link ${isActive ? "text-primary" : "text-dark"}`
            }
          >
            <i className="bi bi-house-door-fill d-block"></i>
            Home
          </NavLink>

          <NavLink
            to="https://www.nseindia.com/"
            className={({ isActive }) =>
              `text-decoration-none text-center bottom-navbar-link ${isActive ? "text-primary" : "text-dark"}`
            }
          >
            <i className="bi bi-star-fill d-block"></i>
            Watchlive
          </NavLink>

          <NavLink
            to="/portfolio"
            className={({ isActive }) =>
              `text-decoration-none text-center bottom-navbar-link ${isActive ? "text-primary" : "text-dark"}`
            }
          >
            <i className="bi bi-folder-fill d-block"></i>
            Portfolio
          </NavLink>

          <NavLink
            to="/dashboard"
            className={({ isActive }) =>
              `text-decoration-none text-center bottom-navbar-link ${isActive ? "text-primary" : "text-dark"}`
            }
          >
            <i className="bi bi-grid-3x3-gap-fill d-block"></i>
            Dashboard
          </NavLink>

          <NavLink
            to="/UserAccount"
            className={({ isActive }) =>
              `text-decoration-none text-center bottom-navbar-link ${isActive ? "text-primary" : "text-dark"}`
            }
          >
            <i className="bi bi-person-circle d-block"></i>
            Account
          </NavLink>

          <NavLink
            to="/profile"
            className={({ isActive }) =>
              `text-decoration-none text-center bottom-navbar-link ${isActive ? "text-primary" : "text-dark"}`
            }
          >
            <i className="bi bi-person-circle d-block"></i>
            profile
          </NavLink>
        </div>
      </nav>
    </>
  );
};

export default BottomNavbar;